import React from 'react'
import './Button.css'
function Button({children, className}) {
  return (
    <a href='https://deconstru.ctf.eng.run/register' className={'button '+className}>{children}</a>
  )
}

export default Button